import { callApi } from '../../../../apiCaller';
import { getCountriesList, toastError } from '../../../../utils';
import { API_GUEST_SUBSCRIBER_LICENSEE_CLIENT } from '../../../../constants';
import { setIsLoading } from '../../../../actions/general';

export const SET_SUBSCRIBER_LICENSEES = 'setSubscriberLicensees';
export const SET_CURRENT_LICENSEE = 'setCurrentLicensee';
export const SET_SUBSCRIBER_LICENSE_ID = 'setSubscriberLicenseeId';
export const SET_COUNTRIES = 'setCountries';

export const setSubscriberLicensees = (licensees) => {
     return {
          type: SET_SUBSCRIBER_LICENSEES,
          payload: licensees,
     };
};

export const setCurrentLicensee = (currentLicensee) => {
     return {
          type: SET_CURRENT_LICENSEE,
          payload: currentLicensee,
     };
};

export const setSubscriberLicenseeId = (licenseId) => {
     return {
          type: SET_SUBSCRIBER_LICENSE_ID,
          payload: licenseId,
     };
};

export const setCountries = (countries) => {
     return {
          type: SET_COUNTRIES,
          payload: countries,
     };
};

export const fetchSubscriberLicenseesRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_GUEST_SUBSCRIBER_LICENSEE_CLIENT, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const countries = getCountriesList(response.data);
               dispatch(setSubscriberLicensees(response.data));
               dispatch(setCountries(countries));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
